import React, { useContext, useEffect, useState } from 'react'
import {
    Button,
    Card,
    CardBody,
    Col,
    CustomInput,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Table
} from 'reactstrap'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'

const emptyForm = {
    id: '',
    code: '',
    name: '',
    description: '',
    color: '',
    maxWidth: '',
    maxHeight: '',
    isActive: true
}

const toNullableNumber = value => value === '' || value === null || value === undefined ? null : Number(value)

const MarialuisasManager = () => {
    const { setLoading } = useContext(GeneralContext)
    const [marialuisas, setMarialuisas] = useState([])
    const [form, setForm] = useState(emptyForm)

    useEffect(() => {
        fetchMarialuisas()
    }, []) // eslint-disable-line

    const fetchMarialuisas = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getMarialuisas()
            setMarialuisas(response.data.marialuisas || [])
        } catch (error) {
            toastr.error('No pude cargar las marías luisa', 'Error')
        } finally {
            setLoading(false)
        }
    }

    const resetForm = () => {
        setForm(emptyForm)
    }

    const saveMarialuisa = async (event) => {
        event.preventDefault()

        if (!form.code || !form.name) {
            toastr.error('Agrega código y nombre para la maría luisa', 'Error')
            return
        }

        try {
            setLoading(true)
            const payload = {
                code: form.code,
                name: form.name,
                description: form.description,
                color: form.color || null,
                maxWidth: toNullableNumber(form.maxWidth),
                maxHeight: toNullableNumber(form.maxHeight),
                isActive: form.isActive
            }

            if (form.id) {
                await ApiService.updateMarialuisa(form.id, payload)
                toastr.success('María luisa actualizada', 'Éxito')
            } else {
                await ApiService.createMarialuisa(payload)
                toastr.success('María luisa agregada', 'Éxito')
            }

            resetForm()
            await fetchMarialuisas()
        } catch (error) {
            toastr.error('No pude guardar la maría luisa', 'Error')
        } finally {
            setLoading(false)
        }
    }

    const editMarialuisa = (marialuisa) => {
        setForm({
            ...emptyForm,
            ...marialuisa,
            color: marialuisa.color || '',
            maxWidth: marialuisa.maxWidth || '',
            maxHeight: marialuisa.maxHeight || ''
        })
    }

    const deleteMarialuisa = async (id) => {
        try {
            setLoading(true)
            await ApiService.deleteMarialuisa(id)
            toastr.success('María luisa eliminada', 'Éxito')
            await fetchMarialuisas()
        } catch (error) {
            toastr.error('No pude eliminar la maría luisa', 'Error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Row>
            <Col md={4} xs={12}>
                <Card>
                    <CardBody>
                        <Form onSubmit={saveMarialuisa}>
                            <FormGroup>
                                <Label>Código *</Label>
                                <Input value={form.code} onChange={event => setForm({ ...form, code: event.target.value })} />
                            </FormGroup>

                            <FormGroup>
                                <Label>Nombre *</Label>
                                <Input value={form.name} onChange={event => setForm({ ...form, name: event.target.value })} />
                            </FormGroup>

                            <FormGroup>
                                <Label>Descripción</Label>
                                <Input value={form.description || ''} onChange={event => setForm({ ...form, description: event.target.value })} />
                            </FormGroup>

                            <FormGroup>
                                <Label>Color</Label>
                                <Input value={form.color || ''} placeholder="#FFFFFF" onChange={event => setForm({ ...form, color: event.target.value })} />
                            </FormGroup>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Ancho máximo</Label>
                                        <Input type="number" min="0" value={form.maxWidth} onChange={event => setForm({ ...form, maxWidth: event.target.value })} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Alto máximo</Label>
                                        <Input type="number" min="0" value={form.maxHeight} onChange={event => setForm({ ...form, maxHeight: event.target.value })} />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <CustomInput
                                type="switch"
                                id="marialuisa-active"
                                label="Activo"
                                checked={form.isActive}
                                onChange={() => setForm({ ...form, isActive: !form.isActive })}
                            />

                            <Button color="primary" className="mt-3" type="submit">
                                <i className="mdi mdi-check"></i> Guardar
                            </Button>

                            {form.id && (
                                <Button className="mt-3 ml-2" onClick={resetForm}>
                                    Cancelar
                                </Button>
                            )}
                        </Form>
                    </CardBody>
                </Card>
            </Col>

            <Col md={8} xs={12}>
                <Card>
                    <div className="table-responsive">
                        <Table striped className="align-middle">
                            <thead>
                                <tr>
                                    <th>Color</th>
                                    <th>Código</th>
                                    <th>Nombre</th>
                                    <th>Máximos</th>
                                    <th>Activo</th>
                                    <th>...</th>
                                </tr>
                            </thead>
                            <tbody>
                                {marialuisas.map(marialuisa => (
                                    <tr key={marialuisa.id}>
                                        <td>
                                            {marialuisa.color && <span style={{ display: 'inline-block', width: 48, height: 32, backgroundColor: marialuisa.color, border: '1px solid #ddd' }} />}
                                        </td>
                                        <td>{marialuisa.code}</td>
                                        <td>{marialuisa.name}</td>
                                        <td>{marialuisa.maxWidth || '-'} x {marialuisa.maxHeight || '-'}</td>
                                        <td>{marialuisa.isActive ? 'Sí' : 'No'}</td>
                                        <td>
                                            <Button size="sm" onClick={() => editMarialuisa(marialuisa)}>
                                                <i className="mdi mdi-pencil"></i>
                                            </Button>
                                            <Button size="sm" className="ml-2" onClick={() => deleteMarialuisa(marialuisa.id)}>
                                                <i className="mdi mdi-trash-can"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card>
            </Col>
        </Row>
    )
}

export default MarialuisasManager
